<tr *ngFor="let e of [].constructor(_rows)">
	@for (column of columns; track column) {
		@if (column.isVisible) {
			<td><skeleton [height]="20"></skeleton></td>
		}
	}
</tr>
